import { createContext, useContext } from "react";

export interface DeploymentUpdateContextValue {
  platformUpdateAvailable: boolean;
  refreshPlatform: () => void;
}

export const DeploymentUpdateContext = createContext<DeploymentUpdateContextValue>({
  platformUpdateAvailable: false,
  refreshPlatform: () => undefined,
});

export function useDeploymentUpdates() {
  return useContext(DeploymentUpdateContext);
}
